<fury-loading-overlay [isLoading]="isLoading" [fill]="true"></fury-loading-overlay>
<div fxFlex fxLayout="column" fxLayoutAlign="space-between">
  <div class="task-panel-header nav">
    <button mat-flat-button (click)="closeEditor()" class="mat-white">
      <mat-icon>chevron_left</mat-icon>
      <span>Terug naar overzicht</span>
    </button>
    <div>
      <fury-page-header-buttons [buttons]="topNavButtons"></fury-page-header-buttons>
    </div>
  </div>
  <div class="task-panel-header" fxLayoutAlign="space-between center">
    <h1 *ngIf="tile">
      Selectie Tegel ({{ tile.name }}) - {{ getTileUsers(tile) }}
    </h1>
  </div>
  <div class="task-panel-header" fxLayoutAlign="space-between center">
    <div [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>Zoeken</mat-label>
        <input matInput [formControl]="form.controls.number" placeholder="Zoek een taak ...">
        <button (click)="clearValue('number');$event.stopImmediatePropagation()"
                *ngIf="form.controls.number.value" aria-label="Clear" mat-icon-button
                matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div>
      <button (click)="getData()" color="primary" mat-raised-button>
        <mat-icon>filter_list</mat-icon>
        Filter
      </button>
    </div>
  </div>
  <div class="task-panel-container">
    <fury-scrollbar class="overflow-container">
      <mat-table (matSortChange)="setSort($event)" [dataSource]="dataSource" matSort>
        <ng-container *ngFor="let column of columns" matColumnDef="{{column.name}}">
          <mat-header-cell *matHeaderCellDef [disabled]="column.name === 'actions' || !column.sortable" mat-sort-header>
            <div class="header-content">
              {{ column.title }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" [style.background-color]="column.name === 'priority_id' && row.priority?.color ? row.priority.color : false">
            <span>
              <ng-container [ngSwitch]="column.name">
                <ng-container *ngSwitchCase="'basic_registration_id'">
                  {{ row.basic_registration?.name }}
                </ng-container>
                <ng-container *ngSwitchCase="'number'">
                  {{ row.number }}
                </ng-container>
                <ng-container *ngSwitchCase="'priority_id'">
                  {{ row.priority?.display_name }}
                </ng-container>
                <ng-container *ngSwitchCase="'handled_days'">
                  <span *ngIf="row.handling.handled_days > 0">
                    <span class="handling_days">
                      <span *ngFor="let items of taskService.handlingDaysRange(row.handling.handling_days, row.handling.handled_days); let i = index;"
                            class="days{{i}}"></span>
                    </span>
                    <span class="handling_text" [class.red]="row?.handling.handled_days > row?.handling.handling_days">
                      {{ row?.handling.handled_days }} dag<span *ngIf="row?.handling.handled_days > 1">en</span>
                    </span>
                  </span>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ row[column.name] }}
                </ng-container>
              </ng-container>
            </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="visibleColumns" class=""></mat-header-row>
        <mat-row *matRowDef="let row; columns: visibleColumns;"
                 [class.active]="lastOpenTaskId === row.id"
                 (click)="lastOpenTaskId = row.id"
                 [routerLink]="'/bekijk/' + row.id"
                 class="clickable route-animations-elements"></mat-row>
        <div *matNoDataRow class="mat-row mat-row-no-data">
          <div class="mat-cell">Geen data beschikbaar</div>
        </div>
      </mat-table>
    </fury-scrollbar>
  </div>

  <mat-paginator (page)="setPagination($event)"
                 [length]="routeParams.length"
                 [pageSizeOptions]="api.pageSizeOptions"
                 [pageSize]="api.pageSize"
                 matPaginationGoToPageDirective
                 class="table-paginator"></mat-paginator>
</div>
